<form #attachTrailerForm="ngForm">
  <sc-title>{{'step title' | translate: ['tmc.transport-attach-detach.dialog.step.title.attach-trailer',
    translationService.language]}}</sc-title>
  <sc-content-spacer [vertical]="true"></sc-content-spacer>
  <sc-string-field name="value" [(ngModel)]="stepperModel.workingData.trailerNumberPlate"
    #ctrlTrailerNumberPlate="ngModel"
    [label]="'trailer numberplate' | translate: ['tmc.transport-attach-detach.dialog.label.trailerNumberPlate', translationService.language]"
    [required]="true" [grow]="true"></sc-string-field>
</form>